import type { AudienceShareRecipient } from '../AudienceForm/types';

export const createDefaultShare = (audienceId: string): AudienceShareRecipient => ({
  recipient_account_id: [],
  audience_external_openaudience_id: audienceId,
  revenue_method: 'PoM',
  value: '',
  isFeeEnabled: false,
});
